<script>
  import Fa from "svelte-fa"
  import { faTrashCan } from "@fortawesome/free-regular-svg-icons"
  import { faCartPlus } from "@fortawesome/free-solid-svg-icons"
  import backend from "../backend"
  import { toast } from "../toast"

  export let ingredients

  async function addToShoppingList(ingredientName) {
    const name = ingredientName?.trim()
    if (!name) return

    try {
      await backend.addIngredientToShoppingList(name)
      const displayName = name.length > 30 ? name.slice(0, 30) + "..." : name
      toast.success(`Added "${displayName}" to shopping list`)
    } catch (error) {
      console.error("Failed to add ingredient to shopping list:", error)
      toast.error("Failed to add ingredient to shopping list")
    }
  }

  let uuid = 0
  let ingredientUuid = 0

  ingredients = ingredients.map((group) => {
    return {
      ...group,
      id: uuid++,
      ingredients: group.ingredients.map((ingredient) => {
        return {
          ...ingredient,
          id: ingredientUuid++
        }
      })
    }
  })

  function addGroup() {
    const newGroup = {
      id: uuid++,
      name: "Group name",
      ingredients: []
    }

    ingredients.push(newGroup)
    ingredients = ingredients
  }

  function deleteGroup(id) {
    ingredients = ingredients.filter((group) => group.id != id)
  }

  function deleteIngredient(groupId, id) {
    let group = ingredients.find((group) => group.id == groupId)

    group.ingredients = group.ingredients.filter(
      (ingredient) => ingredient.id != id
    )

    ingredients = ingredients
  }

  function addIngredient(groupId, event) {
    if (event.key == "Enter" && event.target.value.length > 0) {
      let group = ingredients.find((group) => group.id == groupId)

      const ingredient = {
        id: ingredientUuid++,
        name: event.target.value
      }

      event.target.value = ""
      group.ingredients.push(ingredient)
      ingredients = ingredients
    }
  }
</script>

<main class="flex flex-col gap-4">
  <div
    class="flex flex-row border-b border-dashed border-slate pb-2 items-center"
  >
    <div class="grow text-lg  font-light thick">Ingredients</div>

    <a class="link text-xs" href="#!" on:click={() => addGroup()}>+ group</a>
  </div>

  {#each ingredients as group (group.id)}
    <div class="border-l-4 border-accent pl-4">
      {#if ingredients.length > 1}
        <div class="mb-2 flex flex-row items-center group relative">
          <input
            bind:value={group.name}
            type="text"
            class="font-body font-bold text-lg grow"
            placeholder="Enter group name"
          />

          <button
            type="button"
            class="hidden p-2 text-xs absolute group-hover:block right-1 cursor-pointer text-danger hover:text-danger-hover bg-cream/90 rounded"
            on:click={() => deleteGroup(group.id)}
            data-controller="tooltip"
            data-tooltip-content-value="Delete group"
          >
            <Fa icon={faTrashCan} />
          </button>
        </div>
      {/if}

      <div class="flex flex-col gap-1">
        {#each group.ingredients as ingredient (ingredient.id)}
          <div class="flex gap-1 group items-center relative font-light">
            <input
              bind:value={ingredient.name}
              type="text"
              class="grow overflow-hidden text-ellipsis"
              placeholder="Enter ingredient"
              data-controller="tooltip"
              data-tooltip-content-value={ingredient.name}
              data-tooltip-only-when-overflowing-value="true"
            />

            <button
              type="button"
              class="ml-2 p-1 hidden text-xs group-hover:block right-7 cursor-pointer hover:text-success"
              on:click={() => addToShoppingList(ingredient.name)}
              data-controller="tooltip"
              data-tooltip-content-value="Add to shopping list"
            >
              <Fa icon={faCartPlus} />
            </button>

            <button
              type="button"
              class="p-1 hidden text-xs group-hover:block right-1 cursor-pointer text-danger hover:text-danger-hover"
              on:click={() => deleteIngredient(group.id, ingredient.id)}
              data-controller="tooltip"
              data-tooltip-content-value="Delete"
            >
              <Fa icon={faTrashCan} />
            </button>
          </div>
        {/each}
      </div>

      <div class="mt-1 font-light">
        <input
          type="text"
          placeholder="+ ingredient"
          on:keydown={(event) => addIngredient(group.id, event)}
        />
      </div>
    </div>
  {/each}
</main>

<style>
  input[type="text"] {
    @apply border text-lg md:text-xl border-transparent bg-transparent appearance-none rounded w-full py-0 px-1 text-fg leading-tight cursor-pointer;
    @apply md:text-base md:py-0;
    @apply focus:bg-white focus:shadow focus:border focus:outline-none;
    @apply focus:-m-1 focus:px-2 focus:py-1;
  }
</style>
